import type { ReactNode } from 'react';
import { createContext } from 'react';

interface HeaderSlot {
  headerSlot: ReactNode;
}
export const HeaderSlotContext = createContext<HeaderSlot>({
  headerSlot: null,
});
interface HeaderContext {
  setHeaderSlot: (node: ReactNode) => void;
}

export const HeaderContext = createContext<HeaderContext>({
  setHeaderSlot: () => {},
});
